import * as React from 'react';

export type UIStickyEvent = {
  distanceFromTop: number;
  distanceFromBottom: number;
  eventSource: HTMLElement | Document;
};

export interface UIStickyContextData {
  subscribe: (handler: (event: UIStickyEvent) => void) => void;
  unsubscribe: (handler: (event: UIStickyEvent) => void) => void;
  getParent: () => HTMLElement | null;
}

export const UIStickyContext = React.createContext<UIStickyContextData | null>(null);

export function useUISticky() {
  const context = React.useContext(UIStickyContext);

  if (!context) {
    throw new Error('useContainer must be used inside <Container />');
  }

  return context;
}
